<script setup lang="ts">
import { computed } from 'vue'
import { formatPhone, normalizePhone } from '../phone'
import UiIcon from './UiIcon.vue'

// A phone you can call: "tel:" opens the dialer on the phone, or the VoIP app (Teams, Zoom, softphone)
// on a computer that has one. The number and the icon are both the link. Clicks don't reach clickable rows.
const props = withDefaults(defineProps<{ value: string | null | undefined; icon?: boolean; label?: string }>(), { icon: true })

const digits = computed(() => normalizePhone(props.value))
const text = computed(() => formatPhone(props.value))
const callable = computed(() => digits.value.length >= 8)
</script>

<template>
  <a
    v-if="callable"
    class="ui-phone"
    :href="`tel:+${digits}`"
    :aria-label="`${label ?? 'Ligar para'} ${text}`"
    :title="`${label ?? 'Ligar para'} ${text}`"
    @click.stop
    @keydown.enter.stop
  >
    <UiIcon v-if="icon" name="phone" :size="14" :stroke-width="1.9" />
    <span>{{ text }}</span>
  </a>
  <span v-else-if="text">{{ text }}</span>
</template>

<style scoped>
.ui-phone {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--accent);
  text-decoration: none;
  white-space: nowrap;
}
.ui-phone:hover span {
  text-decoration: underline;
}
</style>
